/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 27 2023
 **/
import { forwardRef } from "react";

import * as Arrow from "./SvgComponents/Arrow";
import * as Common from "./SvgComponents/Common";
import * as Communication from "./SvgComponents/Communication";
import * as Header from "./SvgComponents/Header";
import * as Media from "./SvgComponents/Media";
import * as UI from "./SvgComponents/UI";
import * as Logo from "./SvgComponents/Logo";
import * as Social from "./SvgComponents/Social";
import * as Status from "./SvgComponents/Status";
import * as Toast from "./SvgComponents/Toast";
import * as Object from "./SvgComponents/Object";

export const I = {
	...Arrow,
	...Common,
	...Communication,
	...Header,
	...Media,
	...Logo,
	...UI,
	...Social,
	...Status,
	...Toast,
	...Object
};

export type IconProps = {
	color?: string;
	fill?: React.SVGProps<SVGSVGElement>["fill"];
	size?: React.SVGProps<SVGSVGElement>["width"];
	title?: string;
	titleId?: string;
	desc?: string;
	descId?: string;
} & React.SVGProps<SVGSVGElement>;

export type IconName = keyof typeof I;

export type IconComponentProps = {
	name: IconName;
} & IconProps;

export const Icon = forwardRef(({ name, ...rest }: IconComponentProps, ref: React.Ref<SVGSVGElement> | undefined) => {
	const IconComp = I[name as IconName];
	return <IconComp {...rest} ref={ref} />;
});
